import React from "react";
import { Clock, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatDateLong } from "../lib/campaignStatsUtils";

interface StatsFooterProps {
  createdAt?: string;
  updatedAt?: string;
  onBulkEmail?: () => void;
}

export const StatsFooter: React.FC<StatsFooterProps> = ({
  createdAt,
  updatedAt,
  onBulkEmail,
}) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-1.5 text-slate-600 text-sm">
        <Clock className="w-3.5 h-3.5" />
        <span>Created on {formatDateLong(createdAt)}</span>
        {updatedAt && (
          <>
            <span className="text-slate-300">•</span>
            <span>Last updated {formatDateLong(updatedAt)}</span>
          </>
        )}
      </div>
      {onBulkEmail && (
        <Button
          onClick={onBulkEmail}
          size="sm"
          className="flex items-center gap-1.5 bg-[#A655F8] text-white rounded-lg px-3 py-1.5 text-sm font-semibold shadow-sm shrink-0 transition-colors"
        >
          <Mail className="w-3.5 h-3.5" />
          Bulk Email
        </Button>
      )}
    </div>
  );
};
